
export const SoundReducer = (state = {}, action) => {
  switch (action.type) {
    case 'TRUSTED_SOUND':
      return { isTrusted: true }
    default:
      return state;
  }
}
